// Only 'ua'/'uk' (same content - both keys are just aliases for the same
// file, see resources below) ships in the main bundle. 'en' is the minority
// language here (fallbackLng below is 'ua'), so it's loaded on demand
// instead - see ensureLanguageResources/the changeLanguage wrap below.
import ua from './translation/uk.json'

import {initReactI18next} from 'react-i18next'
import i18n from "i18next";

const resources = {
    ua: {
        translation: ua
    },
    uk: {
        translation: ua
    }
}

const getInitialLanguage = () => {
    try {
        const raw = localStorage.getItem('language');
        if (raw) {
            try {
                return JSON.parse(raw);
            } catch {
                return raw;
            }
        }
    } catch (e) {
        // Fallback if localStorage is inaccessible (e.g. Safari private mode)
    }
    return 'ua';
};

const initialLng = getInitialLanguage();

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: initialLng,
        fallbackLng: 'ua'
    })

// Dynamic import: en.json is ~53KB of JSON that used to ship in the main
// bundle for every visitor, even the (majority, given fallbackLng above)
// who never switch to English - loaded on demand the first time it's
// actually needed instead. hasResourceBundle short-circuits every call
// after the first (including a user flipping en -> ua -> en again), and
// enLoadPromise collapses concurrent callers (the initialLng effect below
// and a fast double-click on the language dropdown) onto the same request
// instead of fetching the chunk twice.
let enLoadPromise = null;
const ensureLanguageResources = (lng) => {
    if (lng !== 'en' || i18n.hasResourceBundle('en', 'translation')) return Promise.resolve();
    if (!enLoadPromise) {
        enLoadPromise = import('./translation/en.json').then(mod => {
            i18n.addResourceBundle('en', 'translation', mod.default || mod, true, true);
        });
    }
    return enLoadPromise;
};

// Wraps (not replaces) the instance's own changeLanguage - every existing
// i18n.changeLanguage(lng) call site (Header.js/HeaderUserMenu.js) keeps
// working unchanged, now transparently waiting on the 'en' bundle when it's
// what's being switched to, instead of briefly rendering fallback ('ua')
// text or missing keys until it happens to arrive later. Same wrap-not-
// replace approach as useAxios.js's own .get override.
const originalChangeLanguage = i18n.changeLanguage.bind(i18n);
i18n.changeLanguage = (lng, ...rest) => lng
    ? ensureLanguageResources(lng).then(() => originalChangeLanguage(lng, ...rest))
    : originalChangeLanguage(lng, ...rest);

// Covers a returning user whose saved language is already 'en' - init()
// above can't await this (it's synchronous on i18next's own side), so the
// bundle is attached as soon as it arrives and react-i18next's own 'loaded'
// event re-renders whatever's already mounted on the 'ua' fallback text.
if (initialLng === 'en') {
    ensureLanguageResources('en');
}

export default i18n
